// extracted by mini-css-extract-plugin
export default {"container":"Title_container__7Z2W2","title":"Title_title__6RgSJ"};